import { getTHERMSImageThumbnailUrl } from "../../Files/utils/get-therms-image-thumbnail-url.js";
import { useAppInteractionHandlers } from "../../AppWrapper2/hooks/useAppInteractionHandlers.js";
import { useRecord } from "../hooks/useRecord.js";
import { recordIcons } from "./record-icons.js";
import "react";
import { Button, Icon, Skeleton } from "@therms/atalaya";
import { IoClose } from "react-icons/io5";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Records/shared/RecordCard.tsx
var RecordCard = ({ className, onDelete, recordId }) => {
	const appInteractionHandlers = useAppInteractionHandlers();
	const { data, loading } = useRecord({ recordId });
	const isClickable = !data?.record.deleted && !!appInteractionHandlers?.onClickRecord;
	if (!recordId || !data?.record) return null;
	return /* @__PURE__ */ jsx("div", {
		className: classnames(className, { "hover:bg-surface-strong active:bg-surface-subtle cursor-pointer transition select-none": isClickable }, "bg-surface-subtle relative overflow-hidden rounded"),
		onClick: isClickable ? () => appInteractionHandlers?.onClickRecord?.(recordId) : void 0,
		children: loading ? /* @__PURE__ */ jsx("div", {
			className: "px-sm flex-1",
			children: /* @__PURE__ */ jsx(Skeleton.Text, { lines: 2 })
		}) : /* @__PURE__ */ jsxs("div", {
			className: classnames({ "opacity-50": data.record.deleted }, "flex"),
			children: [
				!!data.record.primaryImageUrl && /* @__PURE__ */ jsx("img", {
					src: getTHERMSImageThumbnailUrl(data.record.primaryImageUrl),
					alt: data.record.description,
					className: "h-14 w-auto rounded-l object-cover"
				}),
				/* @__PURE__ */ jsxs("div", {
					className: "px-sm relative grow self-center overflow-hidden",
					children: [
						/* @__PURE__ */ jsx(Icon, {
							className: "right-sm absolute inset-y-0 h-full opacity-10",
							Icon: recordIcons[data.record.type],
							color: "neutral-subtle",
							size: "lg"
						}),
						/* @__PURE__ */ jsx("div", {
							className: "text-color-strong truncate font-medium",
							children: data.record.title
						}),
						/* @__PURE__ */ jsx("div", {
							className: "mt-px truncate text-sm",
							children: data.record.description
						}),
						data.record.deleted && /* @__PURE__ */ jsx("div", {
							className: "z-sticky bg-critical/10 text-color-critical p-sm absolute inset-0 flex items-center justify-center rounded font-bold tracking-wider",
							children: "DELETED"
						})
					]
				}),
				!!onDelete && /* @__PURE__ */ jsx(Button, {
					onClick: (e) => {
						e.stopPropagation();
						onDelete(recordId);
					},
					subtle: true,
					variant: "critical",
					size: "sm",
					children: /* @__PURE__ */ jsx(Icon, {
						Icon: IoClose,
						size: "xs",
						className: "mx-xxs"
					})
				})
			]
		})
	});
};
//#endregion
export { RecordCard };

//# sourceMappingURL=RecordCard.js.map